import { render, staticRenderFns } from "./RecordHeader.vue?vue&type=template&id=16bdb1f9&scoped=true&"
import script from "./RecordHeader.vue?vue&type=script&lang=ts&"
export * from "./RecordHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RecordHeader.vue?vue&type=style&index=0&id=16bdb1f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bdb1f9",
  null
  
)

export default component.exports